// extracted by mini-css-extract-plugin
export default {"followButton":"QU-z","followCount":"RU-z","textStyle":"SU-z"};